import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
  const naviagte = useNavigate();
  return (
    <>
      <div
        id="error_page"
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <div
          style={{
            backgroundSize: 'cover',
          }}
        >
          <div
            style={{
              margin: '30px 10%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="secondary"
              size="sm"
              style={{
                backgroundColor: '#CEDBD6',
                fontWeight: 'bolder',
                fontSize: '15px',
                width: '200px',
                // Matches the other back buttons; #e3b448 was 1.35:1 here.
                color: '#664A00',
                marginBottom: '20px',
              }}
              onClick={() => naviagte('/')}
            >
              <ArrowLeftOutlined style={{ fontSize: '15px' }} /> Back to Home
            </Button>
            <h1
              style={{
                color: '#2C3E37',
                fontWeight: 'bolder',
                fontSize: '36px',
              }}
            >
              Page not found
            </h1>
          </div>
        </div>
        <div
          style={{
            backgroundColor: '#CEDBD6',
            backgroundSize: 'cover',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '35px',
          }}
        ></div>
      </div>
    </>
  );
};

export default ErrorPage;
